export default "__VITE_PUBLIC_ASSET__bd9addc7__"